<button
  svc-btn-icon
  iconSize="6"
  type="button"
  icon="heroicons_solid:ellipsis-vertical"
  [id]="buttonId ?? ''"
  [color]="color"
  [processing]="processing"
  [disabled]="disabled"
  [matMenuTriggerFor]="!processing && !disabled && options?.length ? embedMatMenu : null"
></button>
<mat-menu
  #embedMatMenu
  [xPosition]="xPosition || 'before'"
  [yPosition]="yPosition || 'below'"
>
  @for (option of options; track option) {
    @if (!option.hidden) {
      <button
        mat-menu-item
        class="text-default"
        (click)="option.action?.()"
        [disabled]="option.disabled"
      >
        @if (option.icon) {
          <mat-icon
            class="text-current"
            [class]="option.iconSize || 'icon-size-5'"
            [svgIcon]="option.icon"
          />
        }
        <span>{{ option.name }}</span>
      </button>
    }
  }
</mat-menu>
